import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { getTheme } from './theme';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme';
import { AuthProvider } from './contexts/AuthContext';

// Import the router configuration
import { ROUTER_CONFIG } from './constants/routerConfig';

// Providers
import { ConfigProvider } from 'antd';

import './index.css';

const router = createBrowserRouter(ROUTER_CONFIG);
const themeObject = getTheme();
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ConfigProvider theme={themeObject}>
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ThemeProvider>
  </ConfigProvider>
);
